export default {
  "content": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.51 2.935a3 3 0 00-3 3v3.578H5.132a.75.75 0 00-.548 1.261l7.1 7.612a.75.75 0 001.096 0l7.1-7.612a.75.75 0 00-.548-1.261h-3.444V5.935a3 3 0 00-3-3H11.51zm-4.653 8.078h3.153V5.935a1.5 1.5 0 011.5-1.5h1.378a1.5 1.5 0 011.5 1.5v5.078h3.218l-5.374 5.762-5.375-5.762z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M4.75 19.676a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H4.75z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none"
  }
};